import { useStaticQuery, graphql } from 'gatsby'

/**
 * Custom hook to query advertisements and filter based on adplacement and showAd flag.
 *
 * @param {string|null} adplacement - The placement area to filter ads (e.g., 'bygg', 'arkitekt', 'betong').
 * @returns {Array} An array of advertisements filtered by showAd and optionally adplacement.
 */

export const useAdvertisementQuery = (adplacement = null) => {
  const data = useStaticQuery(graphql`
    {
      allWpAdvertisement(
        filter: {
          advertisementSettings: {
            advertisement: { elemMatch: { showAd: { eq: true } } }
          }
        }
      ) {
        nodes {
          title
          data: advertisementSettings {
            adplacement
            advertisement {
              rate
              showAd
              small
              medium
              large
            }
          }
        }
      }
    }
  `)

return data?.allWpAdvertisement?.nodes?.filter(ad =>
  adplacement
    ? ad.data.adplacement?.includes(adplacement)
    : true
)
}